import { render } from "./ActionMenu.vue?vue&type=template&id=4e859782"
import script from "./ActionMenu.vue?vue&type=script&lang=ts"
export * from "./ActionMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script